import { MenuItem as BaseMenuItem, Button, Typography } from '@mui/material';
import { ReactNode, useCallback } from 'react';

import { useMenuButtonStyles } from './useMenuButtonStyles';

interface MenuItemProps {
  startIcon?: ReactNode;
  children?: ReactNode;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
  component?: React.ElementType;
}

export const MenuItem = ({
  children,
  className,
  component = Button,
  disabled,
  onClick,
  startIcon,
}: MenuItemProps) => {
  const { classes, cx } = useMenuButtonStyles({
    isOpened: undefined,
    isLightTheme: undefined,
  });

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();

      if (typeof onClick === 'function') {
        onClick();
      }
    },
    [onClick],
  );

  return (
    <BaseMenuItem
      variant="text"
      disabled={disabled}
      className={cx(classes.menuItem, className)}
      startIcon={<div className={classes.menuItemIcon}>{startIcon}</div>}
      component={component}
      onClick={handleClick}
    >
      <Typography variant="body2" className={classes.menuItemText}>
        {children}
      </Typography>
    </BaseMenuItem>
  );
};
